import React from 'react';
import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import WorkingOnItThrobber from '../../components/Throbbers/WorkingOnItThrobber';
import { useAuth } from 'react-oidc-context';

const Contents: React.FC<React.PropsWithChildren> = ({ children }) => {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <NuvoBox display="flex" justifyContent="center" alignItems="center" height="100vh">
        <WorkingOnItThrobber />
      </NuvoBox>
    );
  }

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    return <>{children}</>;
  } else {
    auth.signinRedirect();
  }

  return (
    <div>
      <button onClick={() => auth.signinRedirect()}>Sign in</button>
    </div>
  );
};

export default React.memo(Contents);
